import axiosapi from "./axiosAPI";

// Get All Incidents
export const getAllIncidents = async (
    setIncidents,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount
) => {
    
    try {
        
        const type = "";
        const page = ((event?.first)/(event?.rows))+1 || 1
        const limit = (event?.rows) || 10

        const res = await axiosapi.get(`/incidents?page=${page}&limit=${limit}&type=${type}`);
        setIncidents(res?.data?.data?.rows ? res?.data?.data?.rows : {});
        setTotalCount(res?.data?.data?.count);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Incidents");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Incidents");
		}
		
	}
	
};



// Get One Incident
export const getOneIncident = async (
    pkid,
    setFetcherror,  
    setIncident
    
)=>{
	try{
		const res =await axiosapi.get(`/incidents/${pkid}`);
        setIncident(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Incident");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Incident");
		}
		
	}
	
};



// Get Specific Incidents
export const getSpecificIncidents = async (
    setIncidents,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    isprocessed,
    isdiscarded,
    isvalid,
    user_id,
    monitorsubmissions,
    globalFilter
) => {
    
    const page = ((event?.first)/(event?.rows))+1 || 1
    const limit = (event?.rows) || 10
    const search =  globalFilter? globalFilter: ""
    
    const options = {
        isprocessed,
        isvalid,
        isdiscarded,
        user_id,
        monitorsubmissions,
        page: page,
        limit: limit,
        search
    }
    
	try{
		const res =await axiosapi.post("/specificincidents",options);
        setIncidents(res.data.data ? res.data.data : {});
        setTotalCount(res.data.totalCount);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Incidents");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Incidents");
		}
		
	}
	
};

// Change Post Status

export const changeIncidentStatus = async (
    incidentpkid,
    isprocessed,
    isdiscarded,
    setIncidents,
    setFetcherror,
    handleAllToasts,
   
              
        ) => {
            // e.preventDefault();

            if (!(isprocessed ||isdiscarded)) {
                handleAllToasts(2, "Discard or Process Statuses not triggered"); 
                    return;  
                }

            const PushItem = {

                id:incidentpkid,
                isprocessed:isprocessed,
                isdiscarded:isdiscarded 
                };

            try{
                await axiosapi.patch("/portalsubmissions/",PushItem );
                handleAllToasts(1, "Submission Discarded Successfully");
                getSpecificIncidents(setIncidents, setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Incident");
                    handleAllToasts(2, "Could Not Update Incident");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Incident");
                    handleAllToasts(2, "Could Not Update Incident");
                    
                }
                
            }
            
};


// Create New Incident
export const createIncident = async (

    fistNameReporter, setFistNameReporter,
    lastNameReporter, setLastNameReporter,
    selectedReporterRole, setSelectedReporterRole,
    phoneReporter, setPhoneReporter,
    emailReporter, setEmailReporter,
    selectedSexReporter, setSelectedSexReporter,
    incidentDescription, setIncidentDescription,
    selectedCountry, setSelectedCountry,
    selectedRegion, setSelectedRegion,
    selectedDistrict, setSelectedDistrict,
    selectedWard, setSelectedWard,
    street, setStreet,
    eventDate, setEventDate,
    selectedBroadCategory, setSelectedBroadCategory,
    selectedCategory, setSelectedCategory,
    selectedSubCategory, setSelectedSubCategory,
    selectedRight, setSelectedRight,
    stepsTaken, setStepsTaken,
    stepsDescription, setStepsDescription,

    fistNameVictim, setFistNameVictim,
    middleNameVictim, setMiddleNameVictim,
    lastNameVictim, setLastNameVictim,
    selectedSexVictim, setSelectSetSexVictim,
    selectedBirthDayVictim, setSelectedBirthDayVictim,
    selectedBirthMonthVictim, setSelectedBirthMonthVictim,
    birthYearVictim, setBirthYearVictim,
    phoneVictim, setPhoneVictim,
    selectedEducationLevelVictim, setESelectedEducationLevelVictim,
    selectedReligionVictim, setSelectedReligionVictim,
    selectedTribeVictim, setSelectedTribeVictim,
    childrenVictim, setChildrenVictim,
    selectedMaritalStatusVictim, setSelectedMaritalStatusVictim,
    selectedMarriageTypeVictim, setSelectedMarriageTypeVictim,
    selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim,
    selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim,
    isVictimVulnerable, setIsVictimVulnerable,
    selectedVulnerabilityVictim, setSelectedVulnerabilityVictim,
    isDisabled, setIsDisabled,
    selectedDisabilityVictim, setSelectedDisabilityVictim,

    fullNamePerpetrator, setFullNamePerpetrator,
    selectedSexPerpetrator, setSelectedSexPerpetrator,
    phonePerpetrator, setPhonePerpetrator,
    relationship, setRelationship,
    assitanceNeeded, setAssitanceNeeded,
    assitanceDescription, setAssitanceDescription,
    files, setFiles, validity, user_id,
    setFetcherror,
    handleAllToasts,
    handleFileUpload,
    operatorinitiated,
    selectedZone, setSelectedZone,
    callback

) => {


    
    
    const birthDate = birthYearVictim + "-" + selectedBirthMonthVictim?.stringValue + "-" + selectedBirthDayVictim?.stringValue;

    if (
        !selectedReporterRole ||
        !incidentDescription ||
        !selectedRegion ||
        !selectedDistrict ||
        !selectedWard ||
        !street ||
        !eventDate ||
        !selectedBroadCategory ||
        !selectedCategory ||
        !selectedSubCategory ||
        !selectedRight ||
        !stepsTaken ||
        !stepsDescription ||
        !fistNameVictim ||
        !lastNameVictim ||
        !birthYearVictim ||
        !selectedEducationLevelVictim ||
        !selectedReligionVictim ||
        !selectedTribeVictim ||
        !selectedMaritalStatusVictim ||
        !selectedEmploymentStatusVictim
    
    ) {
        
        handleAllToasts(2, "Some Mandatory Fields have not been filled Up");
        return;
    }

    const formData = new FormData();
    
    formData.append("firstnamereporter", fistNameReporter);
    formData.append("lastnamereporter", lastNameReporter);
    formData.append("rolereporter", selectedReporterRole?.name);
    formData.append("phoneporter", phoneReporter);
    formData.append("emailreporter", emailReporter);
    formData.append("sexreporter", selectedSexReporter?.name);
    formData.append("eventdescription", incidentDescription);
    formData.append("zone", selectedZone?.name);
    formData.append("region", selectedRegion?.name);
    formData.append("district", selectedDistrict?.name);
    formData.append("ward", selectedWard?.name);
    formData.append("street", street);
    formData.append("eventdate", eventDate);
    formData.append("broadcategory", selectedBroadCategory?.name);
    formData.append("category", selectedCategory?.name);
    formData.append("subcategory", selectedSubCategory?.name);
    formData.append("right", selectedRight?.name);
    formData.append("stepstaken", stepsTaken);
    formData.append("stepstakendescription", stepsDescription);
    formData.append("firstnamevictim", fistNameVictim);
    formData.append("middlenamevictim", middleNameVictim);
    formData.append("lastnamevictim", lastNameVictim);
    formData.append("sexvictim", selectedSexVictim?.name);
    formData.append("birthdayvictim", birthDate);
    formData.append("phonevictim", phoneVictim);
    formData.append("educationlevelvictim", selectedEducationLevelVictim?.name);
    formData.append("religionvictim", selectedReligionVictim?.name);
    formData.append("tribevictim", selectedTribeVictim?.name);
    if (childrenVictim) { formData.append("childrenvictim", childrenVictim) }
    formData.append("maritalstatusvictim", selectedMaritalStatusVictim?.name);
    if (selectedMaritalStatusVictim) { formData.append("marriagetypevictim", selectedMarriageTypeVictim?.name); }
    formData.append("employmentstatusvictim", selectedEmploymentStatusVictim?.name);
    if (selectedEmploymentStatusVictim?.name === "Employed" || selectedEmploymentStatusVictim?.name === "Self-Employed") { formData.append("employmentsectorvictim", selectedEmploymentSectorVictim?.name); }
    formData.append("vulnerabilityvictim", isVictimVulnerable);
    if (selectedVulnerabilityVictim) { formData.append("vulnerabilitytypevictim", selectedVulnerabilityVictim?.name ) }
    formData.append("disabilityvictim", isDisabled); //Create the function to check if PWDs are selected.
    if (selectedDisabilityVictim) { formData.append("disabilitytypevictim", selectedDisabilityVictim?.name) }
    if (fullNamePerpetrator) { formData.append("fullnameperpetrator", fullNamePerpetrator ) }
    if (selectedSexPerpetrator) { formData.append("sexperpetrator", selectedSexPerpetrator?.name ) }
    if (phonePerpetrator) { formData.append("phoneperpetrator", phonePerpetrator ) }
    if (relationship) { formData.append("relationshipperpetrator", relationship) }
     formData.append("assistanceneded", assitanceNeeded ) 
    if (assitanceDescription) { formData.append("assistancedescription", assitanceDescription ) }
    if (user_id) { formData.append("user_id", user_id) };

    formData.append("isprocessed",operatorinitiated? true:false);
    formData.append("isvalid",  (operatorinitiated && validity)? true:false);
    // formData.append("isdiscarded", operatorinitiated? false:false);
    
    files?.forEach((file, index) => {
        formData.append(`files`, file);
      });

    
     
    try{
        
        const response = await axiosapi.post("/incidents/", formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
        
        setFiles(null);
        handleFileUpload();
        setFiles(null);
                handleFileUpload();
                setFistNameReporter("");
                setLastNameReporter("");
                setSelectedReporterRole("");
                setPhoneReporter("");
                setEmailReporter("");
                setSelectedSexReporter("");
                setIncidentDescription("");
                setSelectedCountry("");
                setSelectedZone("");
                setSelectedRegion("");
                setSelectedDistrict("");
                setSelectedWard("");
                setStreet("");
                setEventDate("");
                setSelectedBroadCategory("");
                setSelectedCategory("");
                setSelectedSubCategory("");
                setSelectedRight("");
                setStepsTaken("");
                setStepsDescription("");
                setFistNameVictim("");
                setMiddleNameVictim("");
                setLastNameVictim("");
                setSelectSetSexVictim("");
                setSelectedBirthDayVictim("");
                setSelectedBirthMonthVictim("");
                setBirthYearVictim("");
                setPhoneVictim("");
                setESelectedEducationLevelVictim("");
                setSelectedReligionVictim("");
                setSelectedTribeVictim("");
                setChildrenVictim("");
                setSelectedMaritalStatusVictim("");
                setSelectedMarriageTypeVictim("");
                setSelectedEmploymentStatusVictim("");
                setSelectedEmploymentSectorVictim("");
                setIsVictimVulnerable("");
                setSelectedVulnerabilityVictim("");
                setIsDisabled("");
                setSelectedDisabilityVictim("");
                setFullNamePerpetrator("");
                setSelectedSexPerpetrator("");
                setPhonePerpetrator("");
                setRelationship("");
                setAssitanceNeeded("");
                setAssitanceDescription("");
                handleAllToasts(1, "Incident Created Successfully");
        
                if (typeof callback === "function") callback(null, "Success");

    }
    catch (err) {
       
        if(err.response){
            let errorMsg = "Could Not Create New Incident";
            setFetcherror(`${err.response.status} ${errorMsg}`);
            handleAllToasts(2, "Could Not update The Incident");
            
            if (typeof callback === "function") callback(new Error(`${err.response.status} ${errorMsg}`), null);

        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Incident");
            handleAllToasts(2, "Could Not update The Incident");
            if (typeof callback === "function") callback(new Error("Could Not Create New Incident"), null);
            
        }
        
    }
    
}


// Edit Existing Incident

export const editIncident = async (
    
      incidentpkid,
      fistNameReporter, setFistNameReporter,
      lastNameReporter, setLastNameReporter,
      selectedReporterRole,setSelectedReporterRole,
      phoneReporter, setPhoneReporter,
      emailReporter, setEmailReporter,
      selectedSexReporter, setSelectedSexReporter,
      incidentDescription, setIncidentDescription,
      selectedCountry, setSelectedCountry,
      selectedRegion, setSelectedRegion,
      selectedDistrict, setSelectedDistrict,
      selectedWard, setSelectedWard,
      street, setStreet,
      eventDate, setEventDate,
      selectedBroadCategory, setSelectedBroadCategory,
      selectedCategory, setSelectedCategory,
      selectedSubCategory, setSelectedSubCategory,
      selectedRight, setSelectedRight,
      stepsTaken, setStepsTaken,
      stepsDescription, setStepsDescription,
  
      fistNameVictim, setFistNameVictim,
      middleNameVictim, setMiddleNameVictim,
      lastNameVictim, setLastNameVictim,
      selectedSexVictim, setSelectSetSexVictim,
      selectedBirthDayVictim, setSelectedBirthDayVictim,
      selectedBirthMonthVictim, setSelectedBirthMonthVictim,
      birthYearVictim, setBirthYearVictim,
      phoneVictim, setPhoneVictim,
      selectedEducationLevelVictim, setESelectedEducationLevelVictim,
      selectedReligionVictim, setSelectedReligionVictim,
      selectedTribeVictim, setSelectedTribeVictim,
      childrenVictim, setChildrenVictim,
      selectedMaritalStatusVictim, setSelectedMaritalStatusVictim,
      selectedMarriageTypeVictim, setSelectedMarriageTypeVictim,
      selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim,
      selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim,
      isVictimVulnerable, setIsVictimVulnerable,
      selectedVulnerabilityVictim, setSelectedVulnerabilityVictim,
      isDisabled,setIsDisabled,
      selectedDisabilityVictim, setSelectedDisabilityVictim,
      fullNamePerpetrator, setFullNamePerpetrator,
      selectedSexPerpetrator, setSelectedSexPerpetrator,
      phonePerpetrator, setPhonePerpetrator,
      relationship, setRelationship,
      assitanceNeeded, setAssitanceNeeded,
      assitanceDescription, setAssitanceDescription,
      files, setFiles,validity,
      setFetcherror,
      handleAllToasts,
      handleFileUpload,
      operatorinitiated, fetchIncidents, setEditDialogVisible, monitorNotification, setViewDialogVisible,
      callback
              
        ) => {
            

            const birthDate = birthYearVictim + "-" + selectedBirthMonthVictim?.stringValue + "-" + selectedBirthDayVictim?.stringValue;
           
    if (
        !incidentpkid || 

        !(selectedReporterRole ||
        incidentDescription ||
        selectedRegion ||
        selectedDistrict ||
        selectedWard ||
        street ||
        eventDate ||
        selectedBroadCategory ||
        selectedCategory ||
        selectedSubCategory ||
        selectedRight ||
        stepsTaken ||
        stepsDescription ||
        fistNameVictim ||
        lastNameVictim ||
        birthYearVictim ||
        selectedEducationLevelVictim ||
        selectedReligionVictim ||
        selectedTribeVictim ||
        childrenVictim ||
        selectedMaritalStatusVictim ||
        selectedEmploymentStatusVictim)
    
    ) {
        handleAllToasts(2, "Some Mandatory Fields have not been filled Up"); 
            return; 
        }

            const formData = new FormData();
    
                formData.append("pkid", incidentpkid);
                formData.append("firstnamereporter", fistNameReporter);
                formData.append("lastnamereporter", lastNameReporter);
                formData.append("rolereporter", selectedReporterRole?.name);
                formData.append("phoneporter", phoneReporter);
                formData.append("emailreporter", emailReporter);
                formData.append("sexreporter", selectedSexReporter?.name);
                formData.append("eventdescription", incidentDescription); 
                formData.append("region", selectedRegion?.name);
                formData.append("district", selectedDistrict?.name);
                formData.append("ward", selectedWard?.name);
                formData.append("street", street);
                formData.append("eventdate", eventDate);
                formData.append("broadcategory", selectedBroadCategory?.name);
                formData.append("category", selectedCategory?.name);
                formData.append("subcategory", selectedSubCategory?.name);
                formData.append("right", selectedRight?.name);
                formData.append("stepstaken", stepsTaken);
                formData.append("stepstakendescription", stepsDescription);
                formData.append("firstnamevictim", fistNameVictim);
                formData.append("middlenamevictim", middleNameVictim);
                formData.append("lastnamevictim", lastNameVictim);
                formData.append("sexvictim", selectedSexVictim?.name);
                formData.append("birthdayvictim", birthDate); 
                formData.append("phonevictim", phoneVictim);
                formData.append("educationlevelvictim", selectedEducationLevelVictim?.name);
                formData.append("religionvictim", selectedReligionVictim?.name);
                formData.append("tribevictim", selectedTribeVictim?.name);
                formData.append("childrenvictim", childrenVictim);
                formData.append("maritalstatusvictim", selectedMaritalStatusVictim?.name);
                formData.append("marriagetypevictim", selectedMarriageTypeVictim?.name);
                formData.append("employmentstatusvictim", selectedEmploymentStatusVictim?.name);
                formData.append("employmentsectorvictim", selectedEmploymentSectorVictim?.name);
                formData.append("vulnerabilityvictim", isVictimVulnerable);
                formData.append("vulnerabilitytypevictim", selectedVulnerabilityVictim?.name);
                formData.append("disabilityvictim", isDisabled); //Create the function to check if PWDs are selected.
                formData.append("disabilitytypevictim", selectedDisabilityVictim?.name);
                formData.append("fullnameperpetrator", fullNamePerpetrator); 
                formData.append("sexperpetrator", selectedSexPerpetrator?.name);
                formData.append("phoneperpetrator", phonePerpetrator);
                formData.append("relationshipperpetrator", relationship);
                formData.append("assistanceneded", assitanceNeeded);
                formData.append("assistancedescription", assitanceDescription);
                formData.append("isvalid",  (operatorinitiated && validity)? true:false);
                // formData.append("isdiscarded", operatorinitiated? false:false);
                if (monitorNotification && operatorinitiated) { formData.append("isprocessed", true); }
                files?.forEach((file, index) => {
                    formData.append(`files`, file);
                });


            try{
                await axiosapi.patch("/incidents/", formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
                if (typeof callback === "function") callback(null, "Success");
                fetchIncidents();
                setEditDialogVisible(false);
                if (monitorNotification) {setViewDialogVisible(false) }
                setFiles(null);
                handleFileUpload();
                setFistNameReporter("");
                setLastNameReporter("");
                setSelectedReporterRole("");
                setPhoneReporter("");
                setEmailReporter("");
                setSelectedSexReporter("");
                setIncidentDescription("");
                setSelectedCountry("");
                setSelectedRegion("");
                setSelectedDistrict("");
                setSelectedWard("");
                setStreet("");
                setEventDate("");
                setSelectedBroadCategory("");
                setSelectedCategory("");
                setSelectedSubCategory("");
                setSelectedRight("");
                setStepsTaken("");
                setStepsDescription("");
                setFistNameVictim("");
                setMiddleNameVictim("");
                setLastNameVictim("");
                setSelectSetSexVictim("");
                setSelectedBirthDayVictim("");
                setSelectedBirthMonthVictim("");
                setBirthYearVictim("");
                setPhoneVictim("");
                setESelectedEducationLevelVictim("");
                setSelectedReligionVictim("");
                setSelectedTribeVictim("");
                setChildrenVictim("");
                setSelectedMaritalStatusVictim("");
                setSelectedMarriageTypeVictim("");
                setSelectedEmploymentStatusVictim("");
                setSelectedEmploymentSectorVictim("");
                setIsVictimVulnerable("");
                setSelectedVulnerabilityVictim("");
                setIsDisabled("");
                setSelectedDisabilityVictim("");
                setFullNamePerpetrator("");
                setSelectedSexPerpetrator("");
                setPhonePerpetrator("");
                setRelationship("");
                setAssitanceNeeded("");
                setAssitanceDescription("");
                handleAllToasts(1, "Incident Updated Successfully");
            }
            catch(err){
             
                setFetcherror(`${err.response.status} Could Not Update Incident`);
                handleAllToasts(2, "Could Not Update Incident");
                
                if (typeof callback === "function") callback(new Error(`${err.response.status} Could Not Update Incident`), null);
                
            }
            
};



// Delete Existing Incident.

export const deleteIncident = async (
    incidentpkid,
    setIncidents,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/incidents/${incidentpkid}`);
        let finalData = res.data.message;
        getAllIncidents(setIncidents, setFetcherror);
        handleAllToasts(1, "Incident Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Incident");
            handleAllToasts(2,"Error: Could Not Delete Incident");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Incident");
            handleAllToasts(2,"Error: Could Not Delete Incident");
		}
		
	}
	
};